import { gql } from '@apollo/client';
import { MeetingPlacePageOccasionsListFragment } from '../fragments/meetingPlacePageOccations';
import { fetchOccasionListData } from './meetingPlacePageEventListQuery';

const OCCASION_TENANT_LITE_FRAGMENTS = gql`
  fragment OccasionTenantShopLite on MeetingPlacePageTenantShop {
    __typename
    sys {
      id
    }
    name
    brand {
      ... on LibraryBrandShop {
        sys {
          id
          locale
        }
        name
        slug
        logo {
          description
          url
          height
          width
        }
        coverImage {
          description
          url
          height
          width
        }
      }
      ... on LibraryBrandFoodBeverage {
        sys {
          id
          locale
        }
        name
        slug
        logo {
          description
          url
          height
          width
        }
        coverImage {
          description
          url
          height
          width
        }
      }
      ... on LibraryBrandEntertainment {
        sys {
          id
          locale
        }
        name
        slug
        logo {
          description
          url
          height
          width
        }
        coverImage {
          description
          url
          height
          width
        }
      }
    }
    logo {
      description
      url
      height
      width
    }
  }

  fragment OccasionTenantEntertainmentLite on MeetingPlacePageTenantEntertainment {
    __typename
    sys {
      id
    }
    name
    brand {
      ... on LibraryBrandShop {
        sys {
          id
          locale
        }
        name
        slug
        logo {
          description
          url
          height
          width
        }
        coverImage {
          description
          url
          height
          width
        }
      }
      ... on LibraryBrandFoodBeverage {
        sys {
          id
          locale
        }
        name
        slug
        logo {
          description
          url
          height
          width
        }
        coverImage {
          description
          url
          height
          width
        }
      }
      ... on LibraryBrandEntertainment {
        sys {
          id
          locale
        }
        name
        slug
        logo {
          description
          url
          height
          width
        }
        coverImage {
          description
          url
          height
          width
        }
      }
    }
    logo {
      description
      url
      height
      width
    }
  }

  fragment OccasionTenantFoodBevLite on MeetingPlacePageTenantFoodBeverage {
    __typename
    sys {
      id
    }
    name
    brand {
      ... on LibraryBrandShop {
        sys {
          id
          locale
        }
        name
        slug
        logo {
          description
          url
          height
          width
        }
        coverImage {
          description
          url
          height
          width
        }
      }
      ... on LibraryBrandFoodBeverage {
        sys {
          id
          locale
        }
        name
        slug
        logo {
          description
          url
          height
          width
        }
        coverImage {
          description
          url
          height
          width
        }
      }
      ... on LibraryBrandEntertainment {
        sys {
          id
          locale
        }
        name
        slug
        logo {
          description
          url
          height
          width
        }
        coverImage {
          description
          url
          height
          width
        }
      }
    }
    logo {
      description
      url
      height
      width
    }
  }
`;

const OCCASION_EVENT_LIST_ITEM_LITE_FRAGMENT = gql`
  ${OCCASION_TENANT_LITE_FRAGMENTS}
  fragment OccasionEventListItemLite on MeetingPlacePageEvent {
    __typename
    sys {
      id
    }
    name
    slug
    startDate
    endDate
    hideInListFrom
    mediaField {
      jsonBynderAsset
      altText
    }
    eventTypesCollection {
      items {
        ... on LibraryEventType {
          sys {
            id
          }
          name
        }
      }
    }
    tenant {
      ... on _Node {
        ... on MeetingPlacePageTenantShop {
          ...OccasionTenantShopLite
        }
        ... on MeetingPlacePageTenantEntertainment {
          ...OccasionTenantEntertainmentLite
        }
        ... on MeetingPlacePageTenantFoodBeverage {
          ...OccasionTenantFoodBevLite
        }
      }
    }
    priority
  }
`;

const OCCASION_OFFER_LIST_ITEM_LITE_FRAGMENT = gql`
  ${OCCASION_TENANT_LITE_FRAGMENTS}
  fragment OccasionOfferListItemLite on MeetingPlacePageOffer {
    __typename
    sys {
      id
    }
    name
    slug
    coverImage {
      description
      url
      height
      width
    }
    typeOfOffer {
      sys {
        id
      }
      name
      internalName
    }
    offerCampaignTagsCollection(limit: 2) {
      items {
        tagName
        colour
        type
      }
    }
    date
    validFrom
    validTo
    tenant {
      __typename
      ... on _Node {
        ... on MeetingPlacePageTenantShop {
          ...OccasionTenantShopLite
        }
        ... on MeetingPlacePageTenantEntertainment {
          ...OccasionTenantEntertainmentLite
        }
        ... on MeetingPlacePageTenantFoodBeverage {
          ...OccasionTenantFoodBevLite
        }
      }
    }
  }
`;

const OCCASION_NEWS_LIST_ITEM_LITE_FRAGMENT = gql`
  ${OCCASION_TENANT_LITE_FRAGMENTS}
  fragment OccasionNewsListItemLite on MeetingPlacePageNewsItem {
    __typename
    sys {
      id
    }
    name
    isdatevisible
    slug
    date
    hideInListFrom
    coverImage {
      description
      url
      height
      width
      title
      contentType
      fileName
    }
    tenant {
      ... on _Node {
        ... on MeetingPlacePageTenantShop {
          ...OccasionTenantShopLite
        }
        ... on MeetingPlacePageTenantEntertainment {
          ...OccasionTenantEntertainmentLite
        }
        ... on MeetingPlacePageTenantFoodBeverage {
          ...OccasionTenantFoodBevLite
        }
      }
    }
  }
`;

export const MEETING_PLACE_PAGE_Occasion_LIST_QUERY = gql`
  ${OCCASION_EVENT_LIST_ITEM_LITE_FRAGMENT}
  ${OCCASION_OFFER_LIST_ITEM_LITE_FRAGMENT}
  ${OCCASION_NEWS_LIST_ITEM_LITE_FRAGMENT}
  ${MeetingPlacePageOccasionsListFragment}
  query Occasion_listing_query(
    $limit: Int!
    $skip: Int!
    $id: String!
    $preview: Boolean
    $locale: String!
  ) {
    meetingPlacePageOccasions(id: $id, preview: $preview, locale: $locale) {
      ...MeetingPlacePageOccasionsList
      occasionsCollection(
        limit: $limit
        skip: $skip
        preview: $preview
        locale: $locale
      ) {
        total
        items {
          ... on _Node {
            ... on MeetingPlacePageEvent {
              ...OccasionEventListItemLite
            }
            ... on MeetingPlacePageOffer {
              ...OccasionOfferListItemLite
            }
            ... on MeetingPlacePageNewsItem {
              ...OccasionNewsListItemLite
            }
          }
        }
      }
    }
  }
`;

export const MEETING_PLACE_PAGE_EVENTS_NEWS_QUERY = gql`
  ${OCCASION_EVENT_LIST_ITEM_LITE_FRAGMENT}
  ${OCCASION_NEWS_LIST_ITEM_LITE_FRAGMENT}
  ${MeetingPlacePageOccasionsListFragment}
  query Occasion_events_news_query(
    $limit: Int!
    $skip: Int!
    $id: String!
    $preview: Boolean
    $locale: String!
  ) {
    meetingPlacePageOccasions(id: $id, preview: $preview, locale: $locale) {
      ...MeetingPlacePageOccasionsList
      occasionsCollection(
        limit: $limit
        skip: $skip
        preview: $preview
        locale: $locale
      ) {
        total
        items {
          ... on _Node {
            ... on MeetingPlacePageEvent {
              ...OccasionEventListItemLite
            }
            ... on MeetingPlacePageNewsItem {
              ...OccasionNewsListItemLite
            }
          }
        }
      }
    }
  }
`;

export const MEETING_PLACE_PAGE_OFFERS_QUERY = gql`
  ${OCCASION_OFFER_LIST_ITEM_LITE_FRAGMENT}
  ${MeetingPlacePageOccasionsListFragment}
  query Occasion_offers_query(
    $limit: Int!
    $skip: Int!
    $id: String!
    $preview: Boolean
    $locale: String!
  ) {
    meetingPlacePageOccasions(id: $id, preview: $preview, locale: $locale) {
      ...MeetingPlacePageOccasionsList
      occasionsCollection(
        limit: $limit
        skip: $skip
        preview: $preview
        locale: $locale
      ) {
        total
        items {
          ... on _Node {
            ... on MeetingPlacePageOffer {
              ...OccasionOfferListItemLite
            }
          }
        }
      }
    }
  }
`;

export const MEETING_PLACE_PAGE_OCCATION_LIST_SEO_QUERY = gql`
  query Occasion_listing_seo_query(
    $id: String!
    $preview: Boolean
    $locale: String!
  ) {
    meetingPlacePageOccasions(id: $id, preview: $preview, locale: $locale) {
      name
      slug
      seoDescription
      sys {
        id
        locale
      }
    }
  }
`;

export const MEETING_PLACE_PAGE_Occasion_QUERY = gql`
  query Occasion_query($tagId: String!, $locale: String!) {
    meetingPlacePageOccasionsCollection(
      where: { contentfulMetadata: { tags: { id_contains_some: [$tagId] } } }
      locale: $locale
    ) {
      items {
        sys {
          id
        }
      }
    }
  }
`;

export const MEETING_PLACE_PAGE_Occasion_EXTENDED_NEWS_QUERY = gql`
  query Occasion__news_query(
    $tagId: String!
    $language: String!
    $preview: Boolean
  ) {
    meetingPlacePageNewsListCollection(
      where: { contentfulMetadata: { tags: { id_contains_some: [$tagId] } } }
      locale: $language
      preview: $preview
    ) {
      items {
        name
      }
    }
  }
`;

export const MEETING_PLACE_PAGE_Occasion_EXTENDED_Event_QUERY = gql`
  query Occasion__event_query(
    $tagId: String!
    $language: String!
    $preview: Boolean
  ) {
    meetingPlacePageEventListCollection(
      where: { contentfulMetadata: { tags: { id_contains_some: [$tagId] } } }
      locale: $language
      preview: $preview
    ) {
      items {
        name
      }
    }
  }
`;

export async function getOccasionListPageData(
  occasionListId: string,
  homePageContentfulId: string,
  node_locale: string,
  preview?: boolean,
) {
  const { getApolloClient } = await import('../apolloClient');

  const client = getApolloClient(preview);

  const { MEETING_PLACE_PAGE_HOME_EXTENDED_LOGO_QUERY } =
    await import('./meetingPlacePageEditorialListQuery');

  const [occasionsRes, newsRes, eventRes, homeRes] = await Promise.all([
    // fetchListingData(
    //   MEETING_PLACE_PAGE_Occasion_LIST_QUERY,
    //   'meetingPlacePageOccasions.occasionsCollection',
    //   occasionListId,
    //   node_locale,
    //   preview,
    //   40,
    // ),
    fetchOccasionListData(
      client,
      occasionListId,
      40,
      preview ?? false,
      node_locale,
    ),
    client.query({
      query: MEETING_PLACE_PAGE_Occasion_EXTENDED_NEWS_QUERY,
      variables: {
        language: node_locale,
        tagId: homePageContentfulId,
        preview: preview,
      },
      fetchPolicy: 'no-cache',
      errorPolicy: 'all',
    }),
    client.query({
      query: MEETING_PLACE_PAGE_Occasion_EXTENDED_Event_QUERY,
      variables: {
        language: node_locale,
        tagId: homePageContentfulId,
        preview: preview,
      },
      fetchPolicy: 'no-cache',
      errorPolicy: 'all',
    }),
    client.query({
      query: MEETING_PLACE_PAGE_HOME_EXTENDED_LOGO_QUERY,
      variables: {
        language: node_locale,
        tagId: homePageContentfulId,
        preview: preview,
      },
      fetchPolicy: 'no-cache',
    }),
  ]);

  const homeData =
    (homeRes?.data as any)?.meetingPlacePageHomeCollection?.items[0] || null;

  return {
    meetingPlacePageOccasions: occasionsRes,
    meetingPlacePageHomeCollection: homeData,
    meetingPlacePageNewsList:
      (newsRes?.data as any)?.meetingPlacePageNewsListCollection?.items[0] ||
      null,
    meetingPlacePageEventList:
      (eventRes?.data as any)?.meetingPlacePageEventListCollection?.items[0] ||
      null,
  };
}

